export default "__VITE_ASSET__b8fd5f42__"